import React, { createContext, useContext } from 'react';
import { AuthProvider } from 'react-oidc-context';

import { oidcConfigRetriever } from '@/utils/auth/openidConnectConfig';

import type { AuthApi } from './types';
import useBffCookieAdapter from './useBffCookieAdapter';
import useOidcAdapter from './useOidcAdapter';

type Engine = 'oidc' | 'bff-cookie';

export const AuthContext = createContext<AuthApi | undefined>(undefined);

export function useAuth(): AuthApi {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within <UnifiedAuthProvider>.');
  }
  return ctx;
}

function OidcAuthProviderWrapper({ children }: { readonly children: React.ReactNode }) {
  const value = useOidcAdapter();
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function BffCookieAuthProviderWrapper({ children }: { readonly children: React.ReactNode }) {
  const value = useBffCookieAdapter();
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function BamAuthProvider({
  engine = 'oidc',
  children,
}: {
  readonly engine?: Engine;
  readonly children: React.ReactNode;
}) {
  return engine === 'bff-cookie' ? (
    <BffCookieAuthProviderWrapper>{children}</BffCookieAuthProviderWrapper>
  ) : (
    <AuthProvider {...oidcConfigRetriever()}>
      <OidcAuthProviderWrapper>{children}</OidcAuthProviderWrapper>
    </AuthProvider>
  );
}
